import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b80e6d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview-box" }

import { ref } from 'vue';

import Navbar from '@/components/ui/Navbar.vue';
import Page from '@/components/ui/Page.vue';
import CameraQRCodeReader from '@/components/CameraQRCodeScanner.vue';
import ScanResult from '@/components/ScanResult.vue';
import ScanError from '@/components/ScanError.vue';
import { vibrate } from '@/vibrate';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const result = ref('');
const error = ref('');

const onDecode = (newResult: string) => {
  if (newResult !== result.value) {
    vibrate(500);
  }
  result.value = newResult;
  error.value = '';
};

const onError = (err: string) => {
  error.value = err;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, { class: "page" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CameraQRCodeReader, {
          onDecode: onDecode,
          onError: onError
        })
      ]),
      _createVNode(ScanResult, { result: result.value }, null, 8, ["result"]),
      _createVNode(ScanError, { error: error.value }, null, 8, ["error"]),
      _createVNode(Navbar)
    ]),
    _: 1
  }))
}
}

})